import { rem } from 'polished'
import styled from 'styled-components'

import { DesktopLayoutSizes } from './Common/utils'

import {
  mediaQueryDown,
  mediaQueryOnly,
  mediaQueryUp,
} from 'components/utils/breakpoint'
import { verticalChildSpacing } from 'components/utils/spacing'

export const SavedBottomContent = styled.div`
  ${mediaQueryDown.mobile} {
    ${verticalChildSpacing[16]}
  }

  ${mediaQueryOnly.desktop} {
    ${verticalChildSpacing[16]}
  }

  ${DesktopLayoutSizes} {
    display: grid;
    grid-template:
      'price'
      'cta' auto / 1fr;
    gap: ${rem(16)};
    justify-content: space-between;
    align-items: end;

    ${mediaQueryUp.mobile} {
      grid-template: 'price cta' auto / auto min-content;
    }

    > .price-area {
      grid-area: price;
    }

    > .cta-area {
      grid-area: cta;
      width: 100%;
    }
  }
`
